module.exports = __webpack_public_path__ + "fonts/baronsans-ultrathinitalic-webfont.df43aa55.woff";